<template>
    <div :class="['completed-pr-container', { 'not-complete': !isfinalMsgHouseCompleted }]">
        <div class="final-pr-header" v-if="isfinalMsgHouseCompleted">
            <div class="pr-final-header-left">
                <img :src="require('@/assets/icons/pr-completed.svg')" />
                <div class="completed-msg">
                    <h2 class="title">Key Message Generated</h2>
                </div>
            </div>
            <div class="pr-final-header-right">
                <button class="pr-final-btn-wrapper" @click="goToHome()">
                    <img :src="require('@/assets/icons/home.svg')" alt="">
                    <p class="home-btn-text">Go to Dashboard</p>
                </button>
                <button class="pr-final-btn-wrapper" :disabled="downloadLoader" @click="downloadMessageHouse()">
                    <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                        :width="2"></v-progress-circular>
                    <div v-else class="download-wrapper">
                        <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                        <p>Download</p>
                    </div>
                </button>
            </div>
        </div>
        <div v-else class="edit-title">
            <span class="pr-document-title">{{ originalTitle }}</span>
            <RenamePopup v-if="isEditing" :docName="originalTitle" :isEditing="isEditing"
                @update-isEdit="isEditing = $event" @updated-prTitle="handleTitleUpdate" flowType="messageHouse"  @updated-Title="handleTitleUpdate"/>
            <button class="edit-btn" @click="editTitle">
                <img :src="require('@/assets/icons/edit.svg')" />
            </button>
        </div>

        <div class="completed-pr-wrapper">
            <div class="message-house-content" @mouseup="checkSelection">
                <!-- HTML Content View (when baseMsgHouse is a string) -->
                <div v-if="isHtmlContent" class="html-content-view" v-html="cleanedHtmlContent" ref="detailsContainer">
                </div>

                <!-- JSON Data View -->
                <div v-else>
                    <!-- Completed Message House View -->
                    <div v-if="isCompletedMsgHouse" class="completed-view">
                        <div class="key-message-section">
                            <h2>{{ finalMsgHouseDetails?.keyMessage.title }}</h2>
                            <p>{{ finalMsgHouseDetails?.keyMessage.content }}</p>
                        </div>

                        <div v-for="(visual, index) in finalMsgHouseDetails?.visuals" :key="index"
                            class="visual-section">
                            <div class="Key-title"> KEY MESSAGE {{ index + 1 }}</div>
                            <h3>{{ visual.title }}</h3>
                            <p>{{ visual.description }}</p>

                            <div v-if="visual.points && visual.points.length" class="points-section">
                                <h3>Proof Points for Key Messages {{ index + 1 }}:</h3>
                                <ul>
                                    <li v-for="(point, pointIndex) in visual.points" :key="pointIndex">
                                        {{ point }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Generated Message House View -->
                    <div v-else class="generated-view">
                        <div class="key-message-section">
                            <h2>{{ finalMsgHouseDetails?.keyMessage.title }}</h2>
                            <p>{{ finalMsgHouseDetails?.keyMessage.content }}</p>
                        </div>

                        <div v-for="(visual, index) in finalMsgHouseDetails?.visuals" :key="index"
                            class="visual-section">
                            <div class="Key-title"> KEY MESSAGE {{ index + 1 }}</div>
                            <h3>{{ visual.title }}</h3>
                            <p>{{ visual.description }}</p>

                            <div v-if="visual.points && visual.points.length" class="points-section">
                                <h3>Proof Points for Key Messages {{ index + 1 }}:</h3>
                                <ul>
                                    <li v-for="(point, pointIndex) in visual.points" :key="pointIndex">
                                        {{ point }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <DragActionPopup ref="contextMenu" :show-menu="showContextMenu" :menuPosition="menuPosition"
                    :documentData="popupData" @close="closeContextMenu" :is-article-allowed="true" />

            </div>
            <div class="right-container">
                <div class="meta-data-wrapper">
                    <div class="meta-data-header">
                        <p class="header-title">Source-code Campaigning - generate assets, content and campaigns at
                            scale</p>
                    </div>
                    <div class="assets-container">
                        
                        <div class="assets-wrapper" @click="openGeneratePopup('Social Media Campaign')">
                            <div class="asset-left">
                                <img :src="require('@/assets/icons/social-media-icon.svg')" />
                                <p class="asset-type">Generate Social Media Campaign</p>
                            </div>
                            <img :src="require('@/assets/icons/create-icon.svg')" />
                        </div>
                       
                        <div class="assets-wrapper" @click="createArticle">
                            <div class="asset-left">
                                <img :src="require('@/assets/icons/pr-campaign-icon.svg')" />
                                
                                  <p class="asset-type">Generate Articles</p>
                                     
                            </div>
                            <img :src="require('@/assets/icons/create-icon.svg')" />
                        </div>
                        <div class="assets-wrapper" @click="createArticle">
                            <div class="asset-left">
                                <img :src="require('@/assets/icons/pr-campaign-icon.svg')" />
                                <div class="module-btn">
                                    <p class="asset-type">Generate PR Strategy</p>
                                
                                </div>

                            </div>
                            <img :src="require('@/assets/icons/create-icon.svg')" />
                        </div>
                        <div class="assets-wrapper" @click="openGeneratePopup('Storybank')">
                            <div class="asset-left">
                                <img :src="require('@/assets/icons/storyBoardIcon.svg')" />
                                <p class="asset-type">Generate Storybank</p>
                            </div>
                            <img :src="require('@/assets/icons/create-icon.svg')" />
                        </div>
                    </div>
                </div>
                
                <div class="meta-data-wrapper" v-if="isCompletedMsgHouse">
                    <div class="meta-data-header">
                        <p class="header-title">Details</p>
                    </div>
                    <div class="assets-container">
                        <div class="meta-wrapper">
                            <p class="meta-data">Created On</p>
                            <p class="meta-value">{{ formatDate(finalMsgHouseDetails?.createdAt) }}</p>
                        </div>
                        <div class="meta-wrapper">
                            <p class="meta-data">Completed On</p>
                            <p class="meta-value">{{ formatDate(finalMsgHouseDetails?.updatedAt) }}</p>
                        </div>
                        <div class="meta-wrapper">
                            <p class="meta-data">Created By</p>
                            <p class="meta-value">{{ finalMsgHouseDetails?.createdBy }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Generate Popup Component -->
    <GeneratePopup v-if="generatePopup" v-model="generatePopup" :flowType="selectedFlowType"
        :documentData="documentData">
    </GeneratePopup>
    <v-overlay :model-value="pageLoader" class="overlay" persistent="true">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Generating</span>
    </v-overlay>
</template>

<script>
import RenamePopup from '@/components/RenamePopup.vue';
import CommonPopup from '@/components/CommonPopup.vue';
import GeneratePopup from '@/components/GeneratePopup.vue';
import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';
import moment from 'moment-timezone';
import { downloadPr } from '@/helper/downloadPr';
import DragActionPopup from '@/components/DragPopup.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue';
export default {
    components: {
        RenamePopup,
        CommonPopup,
        GeneratePopup,
        DragActionPopup,
        RotatingLoader
    },
    props: {
        isfinalMsgHouseCompleted: {
            type: Boolean,
            default: false
        },
        isCompletedMsgHouse: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Object,
            default: () => ({})
        },
        msgHouseId: {
            type: String
        },
        title: {
            type: String
        }
    },
    data() {
        return {
            pageLoader:false,
            downloadLoader: false,
            isEditing: false,
            showCommonPopup: false,
            popupType: null,
            typeName: 'message-house',
            originalTitle: null,
            generatePopup: false,
            selectedFlowType: '',
            documentData: null,
            showContextMenu: false,
            menuPosition: { left: 0, top: 0 },
            selectedText: '',
            popupData: null,
            finalMsgHouseDetails: null
        }
    },
    computed: {
        isHtmlContent() {
            return typeof this.finalMsgHouseDetails?.baseMsgHouse === 'string';
        },
        cleanedHtmlContent() {
            if (!this.isHtmlContent) return '';

            const htmlContent = this.finalMsgHouseDetails.baseMsgHouse;
            return htmlContent;
        }
    },
    methods: {
         async saveArticleDraft(articleId) {
            let endpoint = '/article/saveDraft'
            let payload = {
                articleId: articleId,
            }
            let documentData = {};
            documentData = {
                documentId: this.$route.params.msgHouseId,
                documentType: 'MESSAGE_HOUSE',
                section: this.selectedText,
            }

            payload.lastUpdatedStage = 'SOURCE_DOC';
            payload.documentData = documentData
            

            await axiosInstance.put(endpoint, payload)
                .then((response) => {
                    this.showArticleStage = true;
                    this.$router.push({ name: 'ArticleStages', params: { articleId: articleId },state: { locked: true } });
                })
                .catch((error) => {
                    console.error('[ERROR] ', error);
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to save changes',
                    });
                })
        },

        async createArticle() {
            this.pageLoader = true;
            let endpoint = '/article/create';
            let payload = {
                articleDocumentName: null
            }
            await axiosInstance.post(endpoint, payload)
                .then(async (response) => {
                    this.articleId = response.data.data.articleId;
                    if (response.status === 201) {
                        await this.saveArticleDraft(this.articleId)
                    }
                })
                .catch((error) => {
                    Eventbus.emit({
                        snackType: 'error',
                        message: 'Failed to create new article'
                    })
                })
                .finally(() => {
                    this.pageLoader = false;

                })

        },
        handleTitleUpdate(newTitle) {
            this.originalTitle = newTitle;
            this.$emit('update-docTitle', newTitle);
        },
        formatVisualNumber(index) {
            return (index + 1).toString().padStart(2, '0');
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        goToHome() {
            this.$router.push({ name: 'MessageHouseHome' });
        },
        editTitle() {
            this.isEditing = true;
        },
        openGeneratePopup(flowType) {
            this.selectedFlowType = flowType;
            this.generatePopup = true;
        },
        async downloadMessageHouse() {
            this.downloadLoader = true;
            let payload = {
                msgHouseId: this.finalMsgHouseDetails?.msgHouseId,
                flowType: "MESSAGEHOUSE"
            }
            await downloadPr(payload, this.title || this.finalMsgHouseDetails?.msgHouseName);
            this.downloadLoader = false;
        },
        checkSelection() {
            const selection = window.getSelection();
            this.selectedText = selection.toString().trim();
            if (this.selectedText) {
                const range = selection.getRangeAt(0);
                const rect = range.getBoundingClientRect();
                const container = this.$refs.detailsContainer;
                const containerRect = container.getBoundingClientRect();

                this.menuPosition = {
                left: rect.right - containerRect.left + container.scrollLeft,
                top: rect.bottom - containerRect.top + container.scrollTop
            };
                this.popupData = {
                    documentId: this.$route.params.msgHouseId,
                    documentType: 'MESSAGE_HOUSE',
                    sectionContent: this.selectedText,
                }
                this.showContextMenu = true;
            } else {
                this.showContextMenu = false;
            }
        },
        closeContextMenu() {
            this.showContextMenu = false;
        },
        isMardownContent(content) {
            if (!content || typeof content !== "string") return false;

            const markdownPatterns = [
                /^#{1,6}\s/m,                // headings (#, ##, ###)
                /\*\*[^*]+\*\*/,             // bold **text**
                /_[^_]+_/,                   // italic _text_
                /```[\s\S]*```/,             // fenced code block
                /\[([^\]]+)\]\(([^)]+)\)/,   // links [text](url)
                /^>\s/m,                     // blockquotes
            ];

            if (markdownPatterns.some((pattern) => pattern.test(content))) {
                return true;
            }

            return false;
        },
      
    },
    mounted() {
        this.finalMsgHouseDetails = this.modelValue;
        this.originalTitle = this.finalMsgHouseDetails.msgHouseName;
        this.documentData = {
            documentId: this.finalMsgHouseDetails?.msgHouseId,
            documentName: this.finalMsgHouseDetails?.msgHouseName,
            documentType: 'MESSAGE_HOUSE',
            imageUrl: require('@/assets/icons/message-house-icon.svg')
        };
           },
     
}
</script>

<style scoped>
.completed-pr-container {
    display: flex;
    height: 100%;
    flex-direction: column;
    width: 100%;
    padding: 2rem 9rem 2rem 13rem;
    justify-content: space-between;
    gap: 1rem;
    will-change: transform;
    overflow-y: auto;
    scrollbar-width: thin;
}

.completed-pr-wrapper {
    display: flex;
    flex-direction: row;
    gap: 2.5rem;
    flex: 1;
    font-family: 'Inter', sans-serif;
    will-change: transform;
    min-height: 0;
}

.completed-pr-container.not-complete {
    justify-content: center;
}
.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.header {
    position: sticky;
    top: 0;
    right: 0;
    left: 0;
    padding: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF09;
    border-bottom: 1px solid #FFFFFF33;
    color: white;
    z-index: 100;
}

.header-left {
    display: flex;
    gap: 1em;
    align-items: center;
    justify-content: center;
    color: white;
}

.back-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1em;
    background-color: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 50%;
}

.header-title {
    font-size: 16px;
    font-weight: 500;
}

.header-right {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
}

.share-wrapper {
    all: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 12px 8px 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.icon-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5em;
}

.download {
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800);
    opacity: 0.8;
    color: #FFFFFF;
}



.message-house-content {
    display: flex;
    width: 65%;
    flex-direction: column;
    gap: 1rem;
    font-family: 'Inter', sans-serif;
}

.message-house-content :deep(::selection) {
    background: #FF780029;
}

.edit-title {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
}

.pr-title {
    font-size: 18px;
}

.edit-title-input {
    width: 200px;
    align-items: center;
}

.edit-btn {
    display: flex;
    padding: 12px 8px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
}

.details-title {
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    color: #171717;
}

.pr-document-title {
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.completed-view,
.generated-view {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.key-message-section,
.completed-section,
.visual-section {
    margin-bottom: 1.5rem;
    background-color: #FFFFFF;
    border-radius: 10px;
    padding: 2rem;
    gap: 2rem;
}

.key-message-section h2,
.completed-section h3,
.visual-section h3 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #404040;
    background-color: #FFFFFF;
}

.visual-section p {
    margin-bottom: 0.5rem;
}

.points-section h4 {
    font-size: 1rem;
    font-weight: 500;
    margin: 1rem 0 0.5rem;
}

.points-section ul {
    list-style-type: disc;
    padding-left: 1.5rem;
}

.points-section li {
    margin-bottom: 0.3rem;
}

.html-content-view {
    background-color: #FFFFFF;
    border-radius: 10px;
    padding: 2rem;
    color: #171717;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
}

.html-content-view :deep(h1),
.html-content-view :deep(h2),
.html-content-view :deep(h3),
.html-content-view :deep(h4),
.html-content-view :deep(h5),
.html-content-view :deep(h6) {
    color: #404040;
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.html-content-view :deep(p) {
    margin-bottom: 1rem;
}

.html-content-view :deep(ul) {
    list-style-type: disc;
    padding-left: 1.5rem;
    margin-bottom: 1rem;
}

.html-content-view :deep(li) {
    margin-bottom: 0.3rem;
}

.domains-section,
.path-section {
    margin-top: 2rem;
}

.domains-section ul,
.path-section ul {
    list-style-type: none;
    padding-left: 0;
}

.path-section li {
    margin-bottom: 0.5rem;
}

/* Header styles (same as before) */
.final-pr-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5em;
    background: var(--primary-gradient-with-black);
    padding: 1rem 1.5rem;
    border-radius: 8px;
    color: var(--secondary-font-color);
    justify-content: space-between;
}

.pr-final-header-left {
    display: flex;
    gap: 1rem;
}

.pr-final-header-right {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.pr-final-btn-wrapper {
    display: flex;
    gap: 0.5em;
    justify-content: center;
    background: #FFFFFF1F;
    border: 1px solid #FFFFFF33;
    align-items: center;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    font-size: var(--normal-font-size);
    color: white;
}

.download-wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.5em;
    justify-content: center;
    align-items: center;
}

.completed-msg {
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: white;
}

/* Right container styles (same as before) */
.right-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 2rem;
}

.meta-data-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: #ffffff12;
    color: var(--secondary-font-color);
    border-radius: 12px;
}

.meta-data-header {
    padding: 1rem 1.5rem;
    border-bottom: 2px solid #FFFFFF12
}

.assets-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0rem 1.5rem 1rem;
}

.assets-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #FFFFFF13;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    align-items: center;
}

.asset-left {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
}
.module-btn {
    display: flex;
    flex-direction: column;
}

.rolling-out {
    display: flex;
    flex-direction: row;
    padding: 1rem 1.5rem;
    border-bottom: 2px solid #FFFFFF12;
    gap: 1rem;
}

.comming-soon {
    color: #FF7800;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 700;
    font-family: 'Inter';
}

.assets-wrapper.disabled {
    pointer-events: none;
    /* Prevent clicks or hovers */
    opacity: 0.5;
    /* Make it look disabled */
    cursor: not-allowed;
    /* Show the disabled cursor */
}

.meta-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.meta-data {
    color: #FFFFFF99;
}

.meta-value {
    color: white;
}

/* Title editing styles */
.doc-name-editor-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
}

.pr-title {
    font-weight: 500;
    font-size: 1.5rem;
}

.edit-btn {
    background: none;
    border: 1px solid #FFFFFF33;
    border-radius: 8px;
    padding: 8px;
    cursor: pointer;
}

.pr-type-name {
    display: inline-block;
    padding: 0.25rem 1rem;
    border-radius: 4px;
    background: #FFFFFF1F;
    color: white;
    font-size: 0.875rem;
}

hr {
    border: none;
    border-top: 1px solid #E5E5E5;
    margin: 1rem 0;
}

.Key-title {
    color: Orange;
    gap: 2rem;
}
</style>